<template>
	<div class="image-preview-wrap">
		<img :src="imageUrl" fit="cover" class="image-preview-content" />
	</div>
</template>

<script>


export default {
	data() {
		return {
			imageUrl: this.$route.query.imageUrl
		};
	}
};
</script>

<style lang="less" scoped>
.image-preview-wrap {
	width: 100%;
	height: 100vh;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	background: #000;
}
.image-preview-content {
	width: 100%;
}
</style>
